import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';

import { useAuthAvailable } from '../auth/authAvailability';
import { loginRequest } from '../auth/msal';

/**
 * Port of `LoginDisplay.razor`. Renders nothing when OIDC is not configured —
 * see `createMsalInstance` — so the site still works without an identity
 * provider wired up.
 */
export default function LoginDisplay() {
  const authAvailable = useAuthAvailable();
  if (!authAvailable) return null;

  return <MsalLoginDisplay />;
}

function MsalLoginDisplay() {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0];
  const displayName = account?.name ?? account?.username;

  const beginLogIn = () => {
    void instance.loginRedirect(loginRequest);
  };

  const beginLogOut = () => {
    void instance.logoutRedirect();
  };

  return (
    <>
      <AuthenticatedTemplate>
        <span className="login-greeting">Aloha, {displayName}!</span>
        <button type="button" className="login-btn" onClick={beginLogOut}>
          Log out
        </button>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <button type="button" className="login-btn" onClick={beginLogIn}>
          Log in
        </button>
      </UnauthenticatedTemplate>
    </>
  );
}
